import {FormArray, ValidationErrors, ValidatorFn} from "@angular/forms";

export const EmptyOverrideValidator: ValidatorFn = (form: FormArray): ValidationErrors | null => {
  let error = null;
  const {override, transcript} = form.value;

  if (override.length && !transcript.length){
    error = {emptyTranscript: true};
  }
  if (!override.length && transcript.length){
    error = {emptyOverride: true};
  }

  return error;
};
